'use client'
import {Fragment} from "react";
import figma from '../../../../assets/stacks/figma.svg';
import php from '../../../../assets/stacks/php.svg';
import next from '../../../../assets/stacks/nextjs.svg';
import express from '../../../../assets/stacks/express.svg';
import js from '../../../../assets/stacks/js.svg';
import twilio from '../../../../assets/stacks/twilio.svg';
import react from '../../../../assets/stacks/react.svg';
import prisom from '../../../../assets/stacks/prisom.svg';
import photoshop from '../../../../assets/stacks/photoshop.svg';
import mongo from '../../../../assets/stacks/mongo.svg';
import gsap from '../../../../assets/stacks/gsap.svg';
import nest from '../../../../assets/stacks/nest.svg';
import symfony from '../../../../assets/stacks/symfony.svg';
import ai from '../../../../assets/stacks/ai.svg';
import xd from '../../../../assets/stacks/xd.svg';
import laravel from '../../../../assets/stacks/laravel.svg';
import angular from '../../../../assets/stacks/angular.svg';
import mysql from '../../../../assets/stacks/mysql.svg';
import socket from '../../../../assets/stacks/socket.svg';
import aws from '../../../../assets/stacks/aws.svg';
import vue from '../../../../assets/stacks/vue.svg';

const StackCard = (props) => {
    return (
        <div className="container mx-auto">
            <div className="lg:flex flex-row justify-between gap-4 hidden py-10 z-30">
                <div className="flex flex-col gap-2 w-[10%] animate-anni1">
                    <img
                        src={figma}
                        alt="Picture of the author"
                    />
                    <img
                        src={php}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni2">
                    <img
                        src={next}
                        alt="Picture of the author"
                    />
                    <img
                        src={express}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni1">
                    <img
                        src={js}
                        alt="Picture of the author"
                    />
                    <img
                        src={twilio}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni2">
                    <img
                        src={react}
                        alt="Picture of the author"
                    />
                    <img
                        src={prisom}
                        height={"auto"}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni1">
                    <img
                        src={photoshop}
                        alt="Picture of the author"
                    />
                    <img
                        src={mongo}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni2">
                    <img
                        src={gsap}
                        alt="Picture of the author"
                    />
                    <img
                        src={nest}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni1">
                    <img
                        src={symfony}
                        alt="Picture of the author"
                    />
                    <img
                        src={ai}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni2">
                    <img
                        src={xd}
                        alt="Picture of the author"
                    />
                    <img
                        src={laravel}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni1">
                    <img
                        src={angular}
                        alt="Picture of the author"
                    />
                    <img
                        src={mysql}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[10%] animate-anni2">
                    <img
                        src={aws}
                        alt="Picture of the author"
                    />
                    <img
                        src={socket}
                        alt="Picture of the author"
                    />
                    <img
                        src={vue}
                        alt="Picture of the author"
                    />
                </div>
            </div>

            <div className="flex flex-row gap-2 lg:hidden p-4 ">
                <div className="flex flex-col gap-2 w-[20%] animate-anni1">
                    <img
                        src={figma}
                        alt="Picture of the author"
                    />
                    <img
                        src={php}
                        alt="Picture of the author"
                    />
                    <img
                        src={next}
                        alt="Picture of the author"
                    />
                    <img
                        src={express}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[20%] animate-anni2">
                    <img
                        src={js}
                        alt="Picture of the author"
                    />
                    <img
                        src={twilio}
                        alt="Picture of the author"
                    />
                    <img
                        src={react}
                        alt="Picture of the author"
                    />
                    <img
                        src={prisom}
                        height={"auto"}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[20%] animate-anni1">
                    <img
                        src={photoshop}
                        alt="Picture of the author"
                    />
                    <img
                        src={mongo}
                        alt="Picture of the author"
                    />
                    <img
                        src={gsap}
                        alt="Picture of the author"
                    />
                    <img
                        src={nest}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[20%] animate-anni2">
                    <img
                        src={symfony}
                        alt="Picture of the author"
                    />
                    <img
                        src={ai}
                        alt="Picture of the author"
                    />
                    <img
                        src={xd}
                        alt="Picture of the author"
                    />
                    <img
                        src={laravel}
                        alt="Picture of the author"
                    />
                </div>
                <div className="flex flex-col gap-2 w-[20%] animate-anni1">
                    <img
                        src={angular}
                        alt="Picture of the author"
                    />
                    <img
                        src={mysql}
                        alt="Picture of the author"
                    />
                    <img
                        src={socket}
                        alt="Picture of the author"
                    />
                    <img
                        src={aws}
                        alt="Picture of the author"
                    />
                    <img
                        src={vue}
                        alt="Picture of the author"
                    />
                </div>
            </div>
        </div>
    )
}
export default StackCard;
